/** Strip MinerU/SAS image placeholder tags for list display (keep formulas). */
export function stripImageDescriptions(text: string): string {
  if (!text) return text;
  return text
    .replace(/\[图片描述[：:][\s\S]*?\](?:\])?/g, '')
    .replace(/\[图片含公式[：:][\s\S]*?\]\]?/g, '')
    .replace(/\[图片含[^：:]*[：:][\s\S]*?\]\]?/g, '')
    .replace(/\[图片[：:][\s\S]*?\]\]?/g, '')
    .replace(/\[图片\]/g, '')
    .replace(/图\d+\s*/g, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
